import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import './contact.css'
import email from './icons8-subscribe.gif'
import phone from './icons8-whatsapp-48.png'
const Contact = () => {
    return (
        <Container fluid className='custos'>
            <div className="Title mb-5">
                <h3>Contact
                    <span> Contact</span>
                </h3>
            </div>

            <Container className='mt-5 pt-5'>
                <Row>
                    <Col xs={12} md={7} className='cas'>
                        <Card className='c cb box'>
                            <Card.Body>
                                <form className='order mt-3' action="https://formsubmit.co/ibnsifat@gmail.com" method="POST">
                                    <h2 className='text-center py-5  fw-bold'> Send Me an Email</h2>
                                    <input type="hidden" name="_subject" value="mail from portfolio" />
                                    <input type="hidden" name="_captcha" value="false" />
                                    <input className='reservation w-75' type="email" name="email" placeholder="Email Address" required />
                                    <textarea className='reservation w-75' name="message" cols="30" rows="3" placeholder='your message' />
                                    <button className='reservation w-75 bg-secondary text-white' type="submit">Send</button>
                                </form>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col xs={12} md={4} className='ms-5 mt-5 '>
                        <div className="contact-sect">
                            <div className="ContactItem ">
                                <div className="contact">
                                    <img src={phone} alt="" className='ps-4 w-25' />
                                    <div className="right-items">
                                        <h6>Phone</h6>
                                        <p>880-1993517649</p>
                                    </div>
                                </div>
                            </div>
                            <div className="ContactItem ">
                                <div className="contact">
                                    <img src={email} alt="" className='ps-4 w-25' />
                                    <div className="right-items">
                                        <h6>Email</h6>
                                        <p>ibnsifat@gmail.com</p>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </Col>
                </Row>
            </Container>
        </Container>
    );
};

export default Contact;